import styled from 'styled-components';

export const Icon = styled.img`
  margin-right: 18px;
`;
